export default __webpack_public_path__ + "static/media/snyk.fcd20279.svg";